"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BalanceActions = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils");
var _ui = require("../ui");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var arrowRotate = function arrowRotate(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 15V13H3.41L15 1.41L13.59 0L2 11.59V5H0V15H10Z",
    fill: "#25253E"
  }));
};
arrowRotate.defaultProps = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Button = (0, _styledComponents.default)(_ui.Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 233px;\n  &:first-child {\n    margin-right: 10px;\n  }\n  ", "\n"])), _utils.mediaQuery.lessThan('xs')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &:first-child {\n      margin: 0 0 16px 0;\n    }\n  "]))));
var Wrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  ", "\n\n  ", "\n"])), _utils.mediaQuery.lessThan('xs')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    flex-wrap: wrap;\n  "]))), _utils.mediaQuery.lessThan('xl')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", ", ", " {\n      max-width: 100%;\n    }\n  "])), Button, _ui.OutlineButton));
var BalanceActions = function BalanceActions(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, props.onReplenish && /*#__PURE__*/_react.default.createElement(Button, {
    onClick: props.onReplenish,
    color: "secondary",
    iconPosition: "left",
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: arrowRotate,
      size: 10
    })
  }, t('deposit')), /*#__PURE__*/_react.default.createElement(_ui.OutlineButton, {
    className: "ms-auto",
    onClick: props.onSend,
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: arrowRotate,
      size: 10,
      rotate: 180
    })
  }, t('send')));
};
exports.BalanceActions = BalanceActions;